export default [{
  path: '/stage/orderDeatilsData',
  name: 'stage-orderDeatilsData',
  title: '订单详情',
  component: () => import('@/views/stage/template/orderDeatilsData/index')
}];
